import { useCallback } from 'react';

const EXPORT_CSV_STORE_KEY = 'exportCsvStore';

type CsvStore = {
  [key: string]: string; // key -> job_id
};

const getStore = (): CsvStore => {
  try {
    const store = localStorage.getItem(EXPORT_CSV_STORE_KEY);
    return store ? JSON.parse(store) : {};
  } catch (error) {
    console.error('Error reading from localStorage', error);
    return {};
  }
};

const setStore = (store: CsvStore) => {
  try {
    localStorage.setItem(EXPORT_CSV_STORE_KEY, JSON.stringify(store));
  } catch (error) {
    console.error('Error writing to localStorage', error);
  }
};

export const useExportCsvStore = () => {
  const getStatus = useCallback((key: string): string | undefined => {
    return getStore()[key];
  }, []);

  const setStatus = useCallback((key: string, jobId: string) => {
    const store = getStore();
    store[key] = jobId;
    setStore(store);
  }, []);

  const removeStatus = useCallback((key: string) => {
    const store = getStore();
    delete store[key];
    setStore(store);
  }, []);

  return { getStatus, setStatus, removeStatus };
};

export default useExportCsvStore;
